exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--1qu9hhFi4peB8LBNUpDSPv > p {\n  margin: 4px 0;\n}\n\n.auto-dialer--1qu9hhFi4peB8LBNUpDSPv > p:last-of-type {\n  margin: 8px 0;\n}\n\n.auto-dialer--1R_7icZ1u0r_iu9FA6kUw9 {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"memberPhones": "auto-dialer--1qu9hhFi4peB8LBNUpDSPv",
	"memberPhones": "auto-dialer--1qu9hhFi4peB8LBNUpDSPv",
	"memberPhonesLink": "auto-dialer--1R_7icZ1u0r_iu9FA6kUw9",
	"memberPhonesLink": "auto-dialer--1R_7icZ1u0r_iu9FA6kUw9"
};